var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5033 11.8034L12.5988 0.262836C12.5203 0.179517 12.427 0.113416 12.3244 0.0683154C12.2217 0.0232147 12.1116 0 12.0005 0C11.8893 0 11.7793 0.0232147 11.6766 0.0683154C11.574 0.113416 11.4807 0.179517 11.4022 0.262836L0.497704 11.8034C0.180021 12.1398 0 12.5969 0 13.0735C0 14.0633 0.759793 14.8679 1.69431 14.8679H2.84327V23.1028C2.84327 23.5991 3.22184 24 3.69042 24H10.3062V17.7194H13.2712V24H20.3106C20.7792 24 21.1577 23.5991 21.1577 23.1028V14.8679H22.3067C22.7567 14.8679 23.1883 14.6801 23.5059 14.3408C24.1651 13.6399 24.1651 12.5043 23.5033 11.8034Z",
    fill: "#467B3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f2aa2a1ffce748674ffb8fb709e576bb.svg";
export { ForwardRef as ReactComponent };